import { Space } from '../types/Space';

/**
 * Factory function to create Space object
 * @param key string key, NEVER USE DYNAMIC STRINGS
 * @param visible boolean
 * @returns Space object
 */
export const spaceFactory = (key: string, visible = true) => {
  const get = (extraContext?: Space['extraContext']): Space => {
    return {
      key,
      visible,
      // utility types, these'll be calculated after
      exists: false,
      isEmpty: true,
      extraContext,
    };
  };
  return { get };
};
